module.exports = __webpack_public_path__ + "img/Zhomebie01.a2c7d2e1.png";